import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { LoginPage } from './pages/LoginPage';
import { DashboardPage } from './pages/DashboardPage';
import { ReservationsListPage } from './pages/ReservationsListPage';
import { ReservationsSearchPage } from './pages/ReservationsSearchPage';
import { ReservationsCheckPage } from './pages/ReservationsCheckPage';
import { PaymentsPage } from './pages/PaymentsPage';
import { VehiclesPage } from './pages/VehiclesPage';
import { CarClassesPage } from './pages/CarClassesPage';
import { CarNamesPage } from './pages/CarNamesPage';
import { AdminUsersPage } from './pages/AdminUsersPage';
import { UsersPage } from './pages/UsersPage';
import { CouponsPage } from './pages/CouponsPage';
import { PromotionsPage } from './pages/PromotionsPage';
import { UserCouponsPage } from './pages/UserCouponsPage';
import { OptionManagementPage } from './pages/OptionManagementPage';
import { DeliveryExclusionZonesPage } from './pages/DeliveryExclusionZonesPage';
import { PriceAdjustmentsPage } from './pages/PriceAdjustmentsPage';
import { DeliveryBlockedDatesPage } from './pages/DeliveryBlockedDatesPage';
import { CronjobLogsPage } from './pages/CronjobLogsPage';
import { ProtectedRoute } from './components/ProtectedRoute';
import { useAuthStore } from './store/authStore';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      retry: 1,
    },
  },
});

function App() {
  const { isAuthenticated } = useAuthStore();

  return (
    <QueryClientProvider client={queryClient}>
      <BrowserRouter>
        <Routes>
          <Route
            path="/login"
            element={isAuthenticated ? <Navigate to="/" replace /> : <LoginPage />}
          />
          <Route
            path="/"
            element={
              <ProtectedRoute>
                <DashboardPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/reservations/list"
            element={
              <ProtectedRoute>
                <ReservationsListPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/reservations/search"
            element={
              <ProtectedRoute>
                <ReservationsSearchPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/reservations/check"
            element={
              <ProtectedRoute>
                <ReservationsCheckPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/payments"
            element={
              <ProtectedRoute>
                <PaymentsPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/vehicles"
            element={
              <ProtectedRoute>
                <VehiclesPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/vehicles/classes"
            element={
              <ProtectedRoute>
                <CarClassesPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/vehicles/names"
            element={
              <ProtectedRoute>
                <CarNamesPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/admin/users"
            element={
              <ProtectedRoute>
                <AdminUsersPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/users"
            element={
              <ProtectedRoute>
                <UsersPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/coupons"
            element={
              <ProtectedRoute>
                <CouponsPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/promotions"
            element={
              <ProtectedRoute>
                <PromotionsPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/user-coupons"
            element={
              <ProtectedRoute>
                <UserCouponsPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/options"
            element={
              <ProtectedRoute>
                <OptionManagementPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/settings/delivery-exclusion-zones"
            element={
              <ProtectedRoute>
                <DeliveryExclusionZonesPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/settings/price-adjustments"
            element={
              <ProtectedRoute>
                <PriceAdjustmentsPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/settings/delivery-blocked-dates"
            element={
              <ProtectedRoute>
                <DeliveryBlockedDatesPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/cronjob-logs"
            element={
              <ProtectedRoute>
                <CronjobLogsPage />
              </ProtectedRoute>
            }
          />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </BrowserRouter>
    </QueryClientProvider>
  );
}

export default App;
